export default function validation(response, messages) {
  if (!response?.data?.error?.validationErrors) return;

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('LIGNE_COMMANDE_ACHAT_LIEUX_LIVRAISONS_MUST_HAVE_SAME_QUANTITE_AS_LIGNE') === 0) {
      messages.push({ message: 'addEditCommande.lieuLivraison.errors.sameQuantite' });
    }
    if (message.indexOf('LIGNE_COMMANDE_ACHAT_LIEUX_LIVRAISONS_MUST_HAVE_UNIQUE_LIEUX') === 0) {
      messages.push({ message: 'addEditCommande.lieuLivraison.errors.uniqueLieux' });
    }
  });
}
